<p class="w-fit font-bold rounded p-2 border border-grey">{{ text() }}</p>